import type React from 'react';

import st from './ImageChecksPageResults.module.sass';
import {
  DeepfakeSection, ICAOSection, ISOSection, LivenessSection, MinDigitalSection,
} from './sections';
import type { UseTaskDataReturn } from './useTaskData';
import { ResultPanel } from '../../components/index.js';

interface ImageChecksPageResultsProps {
  taskData: UseTaskDataReturn;
}

function ImageChecksPageResults({
  taskData,
}: ImageChecksPageResultsProps): React.JSX.Element {
  const file = taskData?.data?.fileList?.[0];

  return (
    <div className={st.Root}>
      <ResultPanel sourceFileName={file?.name}>
        {!!taskData?.data?.liveness && !!file && <LivenessSection file={file} />}
        {!!taskData?.data?.deepfake && !!file && <DeepfakeSection file={file} />}
        {!!taskData?.data?.iso && !!file && <ISOSection file={file} />}
        {!!taskData?.data?.icao && !!file && <ICAOSection file={file} />}
        {!!taskData?.data?.mindigital && !!file && <MinDigitalSection file={file} />}
      </ResultPanel>
    </div>
  );
}

export { ImageChecksPageResults };
